import React from 'react';
import { useState } from 'react';
import { TRANSLATIONS } from '../../../constants';
import { useAppSelector, useTranslate } from '../../../hooks/common';
import { currentRound, getPowerUnit, getTorqueUnit, powerRound, speedRound, torqueRound } from '../../../services';
import Accordion from '../../common/Accordion';
import DataRow from './DataRow';

const LoadOperationDataConverter = () => {
    const translate = useTranslate();
    const mesRequest = useAppSelector(state => state.motor.mesRequest);
    const calculationResponse = useAppSelector(state => state.motor.calculationResponse);
    const [accordionOpen, toggleAccordion] = useState(true);

    const renderDataRows = () => {
        if (calculationResponse) {
            const { ratedPower, ratedTorque, ratedSpeed, ratedCurrent } = calculationResponse.mesParameters.inputData.vsdMotorData;
            const powerUnit = getPowerUnit(mesRequest.unitSystem);
            const torqueUnit = getTorqueUnit(mesRequest.unitSystem);

            return (
                <div className='data-table'>
                    <DataRow
                        label={translate(TRANSLATIONS.result.converterOperation.ratedPower)}
                        value={`${powerRound(ratedPower)} ${powerUnit}`}
                    />
                    <DataRow
                        label={translate(TRANSLATIONS.result.converterOperation.ratedTorque)}
                        value={`${torqueRound(ratedTorque)} ${torqueUnit}`}
                    />
                    <DataRow
                        label={translate(TRANSLATIONS.result.converterOperation.ratedSpeed)}
                        value={`${speedRound(ratedSpeed)} ${translate(TRANSLATIONS.units.rpm)}`}
                    />
                    <DataRow
                        label={translate(TRANSLATIONS.result.converterOperation.ratedCurrent)}
                        value={`${currentRound(ratedCurrent)} [A]`}
                    />
                </div>
            );
        }
    };

    return (
        <div className='load-operation-data-converter-container'>
            <Accordion
                iconFont={'e90c'}
                label={translate(TRANSLATIONS.result.converterOperation.title)}
                open={accordionOpen}
                onClick={() => toggleAccordion(!accordionOpen)}
            >
                {renderDataRows()}
            </Accordion>
        </div>
    );
};

export default LoadOperationDataConverter;
